import { cloneElement } from 'react';

import Layout from '@/ui/components/layout';
import useIsExtendedLayout from '@/ui/hooks/use-is-extended-layout';
import { cn } from '@/ui/utils/classnames.js';
import FixedHeader from './parts/fixed-header.js';
import ResponsiveHeader from './parts/responsive-header.js';
import useModal from '../../hooks/use-modal.js';
import Navbar from '../navbar/index.js';

function FullScreenModal() {
  const modal = useModal();

  const isExtendedLayout = useIsExtendedLayout();

  if (!modal?.fullscreen) {
    return;
  }

  const {
    id,
    title,
    reactContent,
    onClose,
    canClose = true,
    responsiveLayout,
  } = modal;

  const children = cloneElement(reactContent, {
    onClose,
  });

  return (
    <div className="absolute inset-0 z-[100] flex">
      {isExtendedLayout && <Navbar />}

      <Layout
        className={cn(responsiveLayout ? 'lg:grid-cols-12' : 'h-full')}
        header={
          responsiveLayout ? (
            <ResponsiveHeader
              title={title}
              canClose={canClose}
              onClose={onClose}
            />
          ) : (
            <FixedHeader title={title} canClose={canClose} onClose={onClose} />
          )
        }
        key={id}
        responsive={responsiveLayout}
      >
        {children}
      </Layout>
    </div>
  );
}

export default FullScreenModal;
